"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterOptions = void 0;
const config_1 = require("../config/config");
const BaseRequest_1 = __importDefault(require("../http-requests/BaseRequest"));
const ServiceBaseUrl = `${config_1.API_URL}/advanced-search`;
const getFilterOptions = (id, id_biblioteca, id_colecao, tipo_obra, cancelToken) => {
    return BaseRequest_1.default.axiosInst.get(`${ServiceBaseUrl}/options`, {
        headers: BaseRequest_1.default.publicHeaders(),
        cancelToken,
        params: {
            id,
            id_biblioteca,
            id_colecao,
            tipo_obra,
        },
    });
};
exports.getFilterOptions = getFilterOptions;
